export default __webpack_public_path__ + "static/media/5.7b8088ff.png";